/*
 * Copyright (c) 2021 - Indigen Solutions
 * Authors:
 *   - Peter Magdy <pm@indigen.com>
 * NOTICE: All information contained herein is, and remains
 * the property of Indigen Solutions and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */

import { keyBy } from "lodash";

export class SubjectApi {
    constructor(api) {
        this.api = api;
    }

    async getAll() {
        const items = await this.api.get("/subject");
        return keyBy(items._embedded.subjects, i => i.code);
    }
}
